const ThemePlaceholder = ({ 
  height = 35, 
  width = "100%", 
  className = "", 
  style = {} 
}) => {
  return (
    <span
      className={`placeholder ${className}`}
      style={{ 
        display: "block", 
        height, 
        width, 
        backgroundColor: "#eff2f7", 
        borderRadius: 4,
        ...style 
      }}
    />
  );
};

export default ThemePlaceholder;
